export default __webpack_public_path__ + "static/media/new-cross.19c94b94.svg";